import { Dropdown } from '../Ant';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useFeatureModal } from '../../context/FeatureModalContext';
import { usePopupFocus } from '../../hooks/usePopupFocus';
import NotificationList from './notificationList';

interface NotificationPopoverProps {
  isOpen: boolean;
  onClose: () => void;
  onOpenChange?: (open: boolean) => void;
  children?: React.ReactNode;
}

const NotificationPopover: React.FC<NotificationPopoverProps> = ({
  isOpen,
  onClose,
  onOpenChange,
  children,
}) => {
  const { t } = useTranslation();
  const { isModalVisible } = useFeatureModal();
  const { contentRef, onKeyDown, onBlur, tabIndex } = usePopupFocus<HTMLDialogElement>(
    isOpen,
    onClose,
  );

  useEffect(() => {
    if (isModalVisible && isOpen) {
      onClose();
    }
  }, [isModalVisible, isOpen, onClose]);
  const renderNotificationDropdownContent = () => (
    <dialog
      open
      ref={contentRef}
      className="popup-dialog"
      aria-label={t('common:notifications')}
      tabIndex={tabIndex}
      onKeyDown={onKeyDown}
      onBlur={onBlur}
      data-testid="notification-popover-focus"
    >
      <NotificationList isOpen={isOpen} onClose={onClose} />
    </dialog>
  );

  return (
    <Dropdown
      popupRender={renderNotificationDropdownContent}
      open={isOpen}
      onOpenChange={(open: boolean) => {
        onOpenChange?.(open);
      }}
      trigger={['click']}
      placement="top"
      overlayClassName="notification-container"
      getPopupContainer={(triggerNode) => triggerNode?.parentElement || document.body}
    >
      {children}
    </Dropdown>
  );
};

export default NotificationPopover;
